import TeapotMessageError from "./TeapotMessageError"

export default class ProfileVerificationError extends TeapotMessageError {}
